module.exports = __webpack_public_path__ + "static/media/Spinner.f6cade54.scss";


//////////////////
// WEBPACK FOOTER
// ./src/components/spinner/Spinner.scss
// module id = 820
// module chunks = 0